import { useEffect } from "react";

import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import FlushHostsForm from "./flush-hosts-form";

const FlushHosts = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "DEVELOPER_FLUSH_HOSTS",
      "DEVELOPER_FLUSH_HOSTS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("FLUSH_HOSTS")}
        subTitle={i18n.get("DANGER_TO_PRESS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <FlushHostsForm />
    </ET3PageDiv>
  );
});

export default FlushHosts;
